//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  const curalate = angular.module('curalate');

  curalate.filter('grammaticallyCorrectList', [
    'StringUtils',
    function(
            StringUtils,
        ) {
      return function(list) {
        return StringUtils.toGrammaticallyCorrectList(list);
      };
    },
  ]);
})();
